module.exports = __webpack_public_path__ + "static/media/walleta.b312b054.png";